/** Common English notification phrases → i18n keys under Notifications.* */
const CONTENT_PHRASES = [
  "has liked your post",
  "liked your post",
  "reacted to your post",
  "commented on your post",
  "shared your post",
  "mentioned you in a comment",
  "has accepted your connection request",
  "has started following you",
  "wants to connect you",
  "wants to connect",
  "has viewed your profile",
  "viewed your profile",
  "has posted a content",
];

/**
 * Localize API notification content when the backend still returns English.
 * Leaves already-translated (or unknown) strings unchanged.
 */
export function translateNotificationContent(content, t) {
  if (!content || typeof content !== "string" || typeof t !== "function") {
    return content || "";
  }

  const trimmed = content.trim();
  const lower = trimmed.toLowerCase();

  for (const phrase of CONTENT_PHRASES) {
    if (lower === phrase.toLowerCase()) {
      return t(`Notifications.${phrase}`, { defaultValue: trimmed });
    }
    if (lower.endsWith(phrase.toLowerCase())) {
      const translated = t(`Notifications.${phrase}`, { defaultValue: phrase });
      const prefix = trimmed.slice(0, trimmed.length - phrase.length);
      return `${prefix}${translated}`;
    }
  }

  return trimmed;
}
